import React, { MutableRefObject, useEffect } from 'react';

type Options<T extends HTMLElement> = {
  ref: MutableRefObject<T | null>;
  latency?: number;
  onSingleClick?: (e: React.MouseEvent<T, MouseEvent>) => void;
  onDoubleClick: (e: React.MouseEvent<T, MouseEvent>) => void;
};

export function useDoubleClick<T extends HTMLElement>({
  ref,
  latency = 300,
  onSingleClick = () => null,
  onDoubleClick = () => null,
}: Options<T>) {
  useEffect(() => {
    const clickRef = ref.current;
    let clickCount = 0;
    const handleClick = (e: React.MouseEvent<T, MouseEvent>) => {
      clickCount += 1;

      setTimeout(() => {
        if (clickCount === 1) {
          onSingleClick(e);
        } else if (clickCount === 2) {
          onDoubleClick(e);
        }

        clickCount = 0;
      }, latency);
    };
    clickRef?.addEventListener('click', handleClick as any);

    return () => {
      clickRef?.removeEventListener('click', handleClick as any);
    };
  });
}
